import { Component, OnInit } from '@angular/core';
import { PatientService } from 'src/app/services/patient.service';

@Component({
  selector: 'app-patientotherinfo',
  templateUrl: './patientotherinfo.component.html',
  styleUrls: ['./patientotherinfo.component.scss']
})
export class PatientotherinfoComponent implements OnInit {

  constructor(public patient: PatientService) { }

  ngOnInit(): void {
  }

}
